import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BASE_URL + '/community/';

class CommunityDataService {

    createCommunity(data) {
        return axios.post(
            API_URL + "create/",
            {
                seasonYear: data.year
            },
            {headers: authHeader()}
        );
    }

    getCurrentSeasonYear() {
        return axios.get(
            API_URL + "current-year",
            {headers: authHeader()}
        );
    }

    getAllSubscriptions(data) {
        return axios.post(
            API_URL + "subscriptions/",
            data,
            {headers: authHeader()}
        );
    }

    getSubscription(seasonYear) {
        return axios.get(
            API_URL + "subscription/" + seasonYear,
            {headers: authHeader()}
        );
    }


    getSubscriptionProfits(data) {
        return axios.post(
            API_URL + "subscription-profits/",
            data,
            {headers: authHeader()}
        );
    }

    /**
     * Requests the subscription model based on the current active season
     * @returns {Promise<AxiosResponse<any>>}
     */
    getCurrentSubscription() {
        return axios.get(
            API_URL + "current-subscription/",
            {headers: authHeader()}
        );
    }

}

export default new CommunityDataService();